var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistoryDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "history-delete",
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#e21313"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "delete",
    transform: "translate(8.741 7.811)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_147",
    "data-name": "Group 147",
    transform: "translate(1.558 2.812)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_146",
    "data-name": "Group 146"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    "data-name": "Path 281",
    d: "M514.054,504.658v9.86c0,.43,0,.86,0,1.288a1.456,1.456,0,0,1-.014.21l.037-.279a1.538,1.538,0,0,1-.1.352c.036-.083.071-.168.1-.25a1.538,1.538,0,0,1-.193.332c.054-.071.109-.141.163-.212a1.6,1.6,0,0,1-.25.252l.212-.164a1.553,1.553,0,0,1-.332.2l.25-.1a1.529,1.529,0,0,1-.352.1l.279-.038a3.232,3.232,0,0,1-.406.015h-7.8c-.353,0-.705,0-1.058,0a1.349,1.349,0,0,1-.208-.015l.279.038a1.567,1.567,0,0,1-.354-.1l.25.1a1.478,1.478,0,0,1-.334-.2l.212.164a1.541,1.541,0,0,1-.254-.252l.164.212a1.614,1.614,0,0,1-.2-.332c.036.084.071.168.1.25a1.539,1.539,0,0,1-.1-.352c.013.092.025.187.038.279a3.291,3.291,0,0,1-.015-.459v-9.5c0-.459.009-.919,0-1.376v-.019l-1.049,1.049h10.491c.483,0,.967.006,1.45,0h.021a1.093,1.093,0,0,0,.743-.307,1.055,1.055,0,0,0,0-1.486,1.089,1.089,0,0,0-.743-.306H504.6c-.483,0-.968-.006-1.45,0h-.021a1.064,1.064,0,0,0-1.049,1.049v11.109a2.5,2.5,0,0,0,2.5,2.543h8.292c.268,0,.539.006.807,0a2.5,2.5,0,0,0,2.144-1.284,2.659,2.659,0,0,0,.312-1.265v-11.1a1.092,1.092,0,0,0-.306-.743,1.055,1.055,0,0,0-1.486,0A1.147,1.147,0,0,0,514.054,504.658Z",
    transform: "translate(-502.084 -503.605)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_149",
    "data-name": "Group 149",
    transform: "translate(4.551)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_148",
    "data-name": "Group 148"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_282",
    "data-name": "Path 282",
    d: "M512.266,502.159v1.366l1.049-1.049h-5.98l1.049,1.049v-.758a6.193,6.193,0,0,1,.015-.814c-.013.092-.025.187-.038.279a1.583,1.583,0,0,1,.1-.352c-.036.084-.071.168-.1.25a1.461,1.461,0,0,1,.2-.332l-.164.212a1.531,1.531,0,0,1,.252-.252l-.212.164a1.6,1.6,0,0,1,.332-.2l-.25.1a1.622,1.622,0,0,1,.352-.1l-.279.038a3.764,3.764,0,0,1,.457-.015h2.5a4.174,4.174,0,0,1,.535.015l-.279-.038a1.611,1.611,0,0,1,.352.1l-.25-.1a1.467,1.467,0,0,1,.332.2l-.212-.164a1.529,1.529,0,0,1,.252.252l-.164-.212a1.6,1.6,0,0,1,.2.332c-.036-.084-.071-.168-.1-.25a1.543,1.543,0,0,1,.1.352c-.013-.092-.025-.187-.038-.279.006.071.011.138.011.205a1.1,1.1,0,0,0,.306.743,1.055,1.055,0,0,0,1.486,0,1.08,1.08,0,0,0,.307-.743,2.491,2.491,0,0,0-.833-1.856,2.593,2.593,0,0,0-1.013-.554,2.777,2.777,0,0,0-.668-.086c-.478,0-.954,0-1.433,0h-1.575a2.608,2.608,0,0,0-1.324.34,2.471,2.471,0,0,0-1.175,1.615,6.046,6.046,0,0,0-.061,1.118v.787a1.065,1.065,0,0,0,1.049,1.049h5.98a1.065,1.065,0,0,0,1.049-1.049v-1.366a1.092,1.092,0,0,0-.307-.742,1.052,1.052,0,0,0-1.485,0A1.127,1.127,0,0,0,512.266,502.159Z",
    transform: "translate(-506.282 -499.662)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_151",
    "data-name": "Group 151",
    transform: "translate(0 2.816)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_150",
    "data-name": "Group 150"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_283",
    "data-name": "Path 283",
    d: "M516.038,503.611H501.562c-.195,0-.392,0-.587,0h-.026a1.092,1.092,0,0,0-.742.307,1.053,1.053,0,0,0,0,1.486,1.086,1.086,0,0,0,.742.306h14.475c.195,0,.392,0,.588,0h.025a1.09,1.09,0,0,0,.742-.306,1.053,1.053,0,0,0,0-1.486,1.1,1.1,0,0,0-.742-.307Z",
    transform: "translate(-499.9 -503.61)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_153",
    "data-name": "Group 153",
    transform: "translate(5.519 6.595)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_152",
    "data-name": "Group 152"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_284",
    "data-name": "Path 284",
    d: "M507.639,509.959V515a1.092,1.092,0,0,0,.306.743,1.055,1.055,0,0,0,1.486,0,1.09,1.09,0,0,0,.307-.743v-5.046a1.093,1.093,0,0,0-.307-.743,1.055,1.055,0,0,0-1.486,0,1.1,1.1,0,0,0-.306.743Z",
    transform: "translate(-507.639 -508.909)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_155",
    "data-name": "Group 155",
    transform: "translate(9.623 6.595)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_154",
    "data-name": "Group 154"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_285",
    "data-name": "Path 285",
    d: "M513.393,509.959V515a1.093,1.093,0,0,0,.307.743,1.058,1.058,0,0,0,.742.306,1.069,1.069,0,0,0,.743-.306,1.093,1.093,0,0,0,.306-.743v-5.046a1.1,1.1,0,0,0-.306-.743,1.055,1.055,0,0,0-1.486,0,1.09,1.09,0,0,0-.307.743Z",
    transform: "translate(-513.393 -508.909)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryDelete);
export default __webpack_public_path__ + "static/media/history-delete.c14e9e2b06c00b630f191320a34dcaab.svg";
export { ForwardRef as ReactComponent };